<div class="app-container vis-web-position-relative">
  <vis-web-spinner [showSpinner]="spinner"></vis-web-spinner>
  <vsci-icon-store></vsci-icon-store>
	<visana-lib-header [logoLinkUrl]="'https://www.visana.ch/'+ (activeLang ? activeLang.split('-')[0] : '') "
		[logoLinkTarget]="'_self'">
	</visana-lib-header>
  <ng-template #contactDialog let-closeModal="close" class="modal-lg">
    <div class="modal-header default-cursor-text-unselectable">
      <h4 class="modal-title">{{'common.contact.information' | translate}}</h4>
      <a (click)="closeModal()" class="actionable">
        <vsci-icon meaning="Close" icon="linear-icons-cross" configClasses="fillWhite">
        </vsci-icon>
      </a>
    </div>
    <div class="modal-body modal-scrollable">
      <h2 class="font18 marg-bot40">
        <span>{{'contact.hotline.number' | translate}}<br></span>
        <span class="font16">{{'contact.hotline.open.days' | translate}}
          : {{'contact.hotline.open.hours' | translate}}</span>
      </h2>
    </div>
    <div class="modal-footer">
      <p><a [href]="'basic.footer_imprintUrl' | translate" [target]="'_blank'"
            class="forw-left justify-content-start">{{'common.impressum'
        | translate}}</a></p>
      <button type="button" class="btn justify-content-end" [ngClass]="'btn-secondary'"
              (click)="closeModal()">
        {{'button.action.close-label' | translate}}
      </button>
    </div>
  </ng-template>
  <vsci-application-alert></vsci-application-alert>
  <main class="vis-web-main">
    <section class="vis-web-app-content">
      <div>
        <app-search-criteria></app-search-criteria>
        <app-search-result></app-search-result>
      </div>
    </section>
  </main>
  <div class="block120"></div>
   	<visana-lib-footer id="vacanza-footer" 
		[links]="footerLinks$ | async" 
		[currentLanguage]="activeLang"
		(languageChange)="changeLang($event)">
  	</visana-lib-footer>
</div>

